export default () => ({
  terminalModel: ''
})
